import React from 'react';
import Hero from '../components/Hero';
import Products from '../components/Products';
import OurExpertise from '../components/OurWorks';
import Clients from '../components/Clients';
// import Testimonials from '../components/Testimonials';
import Blog from '../components/Blog';
import Contact from '../components/Contact';
import CTA from '../components/CTA';
// import Services from '../components/Services';

import { Helmet } from 'react-helmet-async';

const Home = () => {
    return (
        <>
          <Helmet>
                <title>Mini App Tech - Digital Solutions & Software Development</title>
                <meta name="description" content="Innovative digital solutions for modern businesses. Specializing in web and mobile app development." />
                <meta name="keywords" content="mini app tech, web development, app development, digital solutions, software company india, ERP development" />
            </Helmet>
            <Hero />
            <Clients/>
            <OurExpertise />
            <Products />
            {/* <Services /> */}
            {/* <Testimonials /> */}
            <Blog />
            <CTA />
            <Contact />
        </>
    );
};

export default Home;
